import { NavigationGuard } from 'vue-router'
import { getToken } from '@/packages/cookie'
import { showInfo } from '@/packages/toast'
import i18n from '@/config/i18n'
import store from '@/store'
import { isPrivate } from './helpers'

const isSessionAlive = () => {
  return getToken()
}

export const sessionGuard: NavigationGuard = (to, from, next) => {
  if (isPrivate(to) && !isSessionAlive()) {
    showInfo(i18n.tc('errors.sessionTimeout'))
    store.dispatch('auth/logout')
    next({ name: 'Login' })
  } else {
    next()
  }
}
